import { useState, type ReactNode } from "react";
import type { AuthProvider } from "@pack-it-up/core";
import { Button, vars } from "@pack-it-up/ui-web";
import { useStores } from "../../app/AppContext.js";
import { GoogleIcon } from "../../app/icons.js";

// Federated sign-in buttons shared by the sign-in and sign-up screens (T22 §5).
// Provider sign-in doubles as sign-up on first use, so both screens render the
// same component.
export const ProviderButtons = (): ReactNode => {
  const { auth } = useStores();
  const [busy, setBusy] = useState<AuthProvider["kind"] | null>(null);

  // No imperative navigate on success — the auth-stream gate flip routes the app
  // (see SignUp.tsx for the stale-navigate race this avoids).
  const signIn = async (provider: AuthProvider): Promise<void> => {
    if (busy !== null) return;
    setBusy(provider.kind);
    await auth.getState().signInWithProvider(provider);
    setBusy(null);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", color: vars.color.textMuted, fontSize: vars.font.sizeXs }}>
        <div style={{ flex: 1, height: "1px", background: vars.color.border }} />
        or continue with
        <div style={{ flex: 1, height: "1px", background: vars.color.border }} />
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        <Button
          variant="secondary"
          onClick={() => void signIn({ kind: "google" })}
          disabled={busy !== null}
          style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
        >
          {GoogleIcon}
          Google
        </Button>
      </div>
    </div>
  );
};
